import { v1 } from "uuid"
const uuid = { v1 }

export const baseRow = {
  height: "100%",
  alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
  openIndex: 0, //手风琴默认展开项
}
export const baseCol = {
  uid: "emptyLayoutComponentRootBox",
  alignSelf: "stretch",
  width: "100%",
  elementOptions: []
}
export const baseComponentBoxOptions = {
  showAutoLayout: false,
  direction: "vertical", // vertical  horizon
  alignPositionH: "left", // left center right
  alignPositionV: "top", // top middle bottom
  marginBottom: 0, //自动布局时 组件之间的间距
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  borderStyle: "dashed", // solid, dashed, dotted
  borderColor: "rgba(0, 71, 255, 1)",
  borderWidth: 0,
  borderIsThemeColor: false,
  clipSize: "cover",
  repeatType: "no-repeat",
  alignType: "center center",
  imgSrc: "",
  opacity: 100,
  paddingType: "global", //自定义边框类型，global表示设置一次，上下左右的padding都变，single表示单个设置
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,
  bgColorType: "自定义",
  bgColor: "rgba(255,255,255,0)",
  // startColor: "rgba(7,21,60,1)",
  // endColor: "rgba(37,129,220,1)",
  // bgOpacity: 1
  background: []
}
export class LayoutGenerator {
  constructor(opt) {
    this.rows = []
    this.init(opt)
  }
  init(opt) {
    this.addTable(opt, this.rows)
  }
  addTable(opt, head) {
    opt.rows.forEach(itemRow => {
      const tempRow = { ...baseRow }
      tempRow.height = itemRow.height //初始化模板row的高度
      if (itemRow.hasOwnProperty("cols") && Array.isArray(itemRow.cols) && itemRow.cols.length) {
        tempRow.cols = []
        itemRow.cols.forEach((itemCol, itemColIndex) => {
          const tempCol = { ...baseCol }
          tempCol.elementOptions = opt.elementOptions || [] //初始化模板col的elementoption数组
          this.initComponentBoxOptions(tempCol, itemCol) //初始化componentbox
          this.initColsOption(tempCol, itemCol) //initColsOption,例如alignSelf
          tempCol.uid = itemCol.uid || uuid.v1()
          tempRow.cols.push(tempCol)
          if (itemCol.hasOwnProperty("rows") && Array.isArray(itemCol.rows) && itemCol.rows.length) {
            tempRow.cols[itemColIndex].rows = []
            // 递归调用本身生成row，并且传递新的头指针
            this.addTable(itemCol, tempRow.cols[itemColIndex].rows)
          }
        })
      }
      head.push(tempRow)
    })
  }
  initComponentBoxOptions(tempCol, itemCol) {
    tempCol.componentBoxOptions = { ...baseComponentBoxOptions } //初始化模板col的elementoption数组
    //如果传了componentbox参数，则对basecol的componentbox参数进行覆盖
    if (itemCol.hasOwnProperty("componentBoxOptions")) {
      if (Object.prototype.toString.call(itemCol.componentBoxOptions) === "[object Object]") {
        for (let k in itemCol.componentBoxOptions) {
          tempCol.componentBoxOptions[k] = itemCol.componentBoxOptions[k]
        }
      }
    }
  }
  initColsOption(tempCol, itemCol) {
    for (const k in itemCol) {
      if (itemCol.hasOwnProperty(k) && k !== "componentBoxOptions") {
        tempCol[k] = itemCol[k]
      }
    }
  }
}
